import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { NotFoundComponent } from './pages/other-pages/not-found/not-found.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [

  /* =======================
   * AUTH LAYOUT (LOGIN ONLY)
   * ======================= */
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/login/login.component')
            .then(c => c.LoginComponent),
      },
    ],
  },

  /* =======================
   * ORGANIZER REGISTER (NO LAYOUT)
   * ======================= */
  {
    path: 'organizer-register',
    loadComponent: () =>
      import('./features/auth/organizer-register/organizer-register.component')
        .then(c => c.OrganizerRegisterComponent),
  },

  /* =======================
   * PRINT PAGE
   * ======================= */
  {
    path: 'print-page',
    loadComponent: () =>
      import('./features/print-page/print-page.component')
        .then(c => c.PrintPageComponent),
  },

  /* =======================
   * ADMIN LAYOUT
   * ======================= */
  {
    path: 'main',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/events/events.routes')
            .then(m => m.EVENTS_ROUTES),
      },
    ],
  },

  /* =======================
   * 404
   * ======================= */
  {
    path: '**',
    component: NotFoundComponent,
  },
];

